export function getUrlParams() {
  const {search} = window.location
  if(!search.includes('?')) return {}
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split('=')

    // Change Q to term for search
    if(key.toLowerCase() === "q"){
      key = "Term";
    }

    return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}


export function pushUrlParams(params) 
{
  if(params.Size){
    delete params.Size;
  }

  // Change Term to Q in url for google
  if(params.Term){
    params.Q = params.Term;
    delete params.Term;
  }
  
  const query = Object.keys(params).map(key => `${key}=${encodeURI(params[key])}`).join('&');
  const pathQuery = query.length > 0 ? `${window.location.pathname}?${query}` : `${window.location.pathname}`;
  window.history.pushState('', '', pathQuery);
}

